module.exports = __webpack_public_path__ + "img/Satisfactory.7546e43f131212d943ab32179eeaf69f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Satisfactory.png
// module id = 767
// module chunks = 0